/** 页面路由 */
export enum PageRoutes {
  /** 首页 */
  Home = '/',
  /** 行情 */
  Quote = '/quote',
  /** 现货交易 */
  SpotTrade = '/spot-trade',
  /** 法律与合规 */
  LegalCompliance = '/legal-compliance',
  /** 登录 */
  Login = '/login',
  /** 登录输入密码 */
  LoginInputPassword = '/login-input-password',
  /** 忘记密码 */
  PreForgetPassword = '/pre-forget-password',
  /** 重置密码 */
  ResetPassword = '/reset-password',
  /** 注册 */
  Register = '/register',
  /** 注册输入密码 */
  RegisterPassword = '/register-password',
  /** 注册邮箱验证 */
  RegisterAuthEmail = '/register-auth-email',
  /** 注册手机验证 */
  RegisterAuthMobile = '/register-auth-mobile',
  /** 资产 */
  Asset = '/asset',
  /** 资产概览 */
  AssetOverview = '/asset-overview',
  /** 资金账户 */
  AssetFund = '/asset-fund',
  /** 合约账户 */
  AssetContract = '/asset-contract',
  /** 衍生品账户 */
  AssetDerivative = '/asset-derivative',
  /** 用户中心 */
  UserCenter = '/user-center',
  /** 合约交易 */
  ContractTrade = '/contract-trade',
  /** 帮助中心 */
  HelpCenter = '/help-center',
  /** 投资 */
  Invest = '/invest',
  /** 投资产品详情 */
  InvestProductDetail = '/invest-product-detail',
}

/** 用户中心路由 */
export enum UserCenterRoutes {
  AssetFund = 'asset-fund',
  /** 合约账户 */
  AssetContract = 'asset-contract',
  /** 衍生品账户 */
  AssetDerivative = 'asset-derivative',
  /** 账单 */
  AssetBill = 'asset-bill',
  /** 现货订单 */
  SpotOrder = 'spot-order',
  /** 合约订单 */
  ContractOrder = 'contract-order',
  /** 个人概览 */
  UserOverview = 'user-overview',
  /** 推广中心 */
  PromotionCenter = 'promotion-center',
  /** 推广中心-我的邀请 */
  MyInvitation = 'my-invitation',
  /** 推广中心-好友详情 */
  FriendDetails = 'friend-details',
  /** 实名认证 */
  RealNameAuth = 'real-name-auth',
  /** 安全设置 */
  SecuritySettings = 'security-settings',
  /** 充值 */
  Recharge = 'recharge',
  /** 提币 */
  Withdraw = 'withdraw',
  /** 身份认证 */
  IdentityVerification = 'identity-verification',
  /** 身份审核中 */
  IdentityReviewPending = 'identity-review-pending',
  /** 活体认证 */
  LivenessVerification = 'liveness-verification',
  /** 视频认证 */
  VideoVerification = 'video-verification',
  /** 理财账户 */
  AssetFinance = 'asset-finance',
  /** 理财历史 */
  FinancialHistory = 'financial-history',
}

export const getAssetsPageRoute = (route: UserCenterRoutes) => {
  return `${PageRoutes.UserCenter}/${route}`
}

export const getUserCenterPageRoute = (route: UserCenterRoutes) => {
  return `${PageRoutes.UserCenter}/${route}`
}
